import { MaterialUICore, tokens } from '@iclinic/design-system';

const { makeStyles } = MaterialUICore;

const useStyles = makeStyles(() => ({
  suggestionsBox: {
    overflow: 'hidden',
  },
  title: {
    fontWeight: tokens.font.weight.medium,
    fontSize: tokens.font.size.xxxs,
    lineHeight: tokens.line.height.sm,
    color: tokens.color.neutral[500],
  },
}));

export default useStyles;
